import { useLanguage } from '../contexts/LanguageContext';
import { Server, Cpu, HardDrive, ExternalLink, ChevronRight, Wifi, WifiOff } from 'lucide-react';

const ServerCard = ({ server, onEdit, onDelete, isAdmin }) => {
  const { t } = useLanguage();

  const connectionLink = server.connectionType === 'url'
    ? server.url
    : `http://${server.ip}${server.port ? `:${server.port}` : ''}`;

  const handleCardClick = (e) => {
    if (e.target.closest('button') || e.target.closest('a')) {
      return;
    }
    if (connectionLink) {
      window.open(connectionLink, '_blank', 'noreferrer');
    }
  };

  const statusColor = server.status === 'online' ? '#10b981' : '#ef4444';

  return (
    <div
      className="server-feature-card"
      onClick={handleCardClick}
      style={{ '--server-color': statusColor }}
    >
      <div className="server-card-icon">
        <Server size={28} />
      </div>
      <h3>
        <a href={connectionLink} target="_blank" rel="noreferrer">
          {server.name}
          <ExternalLink size={16} />
        </a>
      </h3>
      <div className="server-card-status">
        {server.status === 'online' ? <Wifi size={14} /> : <WifiOff size={14} />}
        <span>{server.status === 'online' ? 'Online' : 'Offline'}</span>
      </div>
      <div className="server-card-specs">
        <div className="spec-item">
          <Cpu size={16} />
          <span>{server.cpu}</span>
        </div>
        <div className="spec-item">
          <HardDrive size={16} />
          <span>{server.ram}</span>
        </div>
      </div>
      <div className="server-card-connection">
        {server.connectionType === 'url' ? (
          <>{t('url')}: <a href={server.url} target="_blank" rel="noreferrer">{server.url}</a></>
        ) : (
          <>{t('ip')}: <a href={connectionLink} target="_blank" rel="noreferrer">{server.ip}{server.port ? `:${server.port}` : ''}</a></>
        )}
      </div>
      {isAdmin && (
        <div className="server-card-actions">
          <button className="server-btn-edit" onClick={() => onEdit(server)}>
            {t('edit')}
          </button>
          <button className="server-btn-delete" onClick={() => onDelete(server.id)}>
            {t('delete')}
          </button>
        </div>
      )}
      <div className="server-card-arrow">
        <ChevronRight size={20} />
      </div>
    </div>
  );
};

export default ServerCard;
